module.exports = __webpack_public_path__ + "static/assets/7691e0682d3855f163ceee281d61e23b.png";